export const solutions = [
  {
    id: 'sys-sf',
    title: '收费难，对账烦',
    hoverTitle: '解决方案：智能收费管理系统',
    desc: '收缴率低，人工催费效率差，财务对账复杂，资金周转慢，收费透明度低导致业主信任度下降。',
    hoverDesc: '一站式解决缴费、催缴、对账、公示全流程问题',
    img: '/images/sys-sf.png',
    hoverImg: '/images/sys-sf-l.png',
    hoverItems: [
      {
        title: '线上缴费',
        itemDesc: '支持支付宝/微信/银行卡，24小时自助缴费',
      },
      {
        title: '自动催缴',
        itemDesc: '短信/微信智能提醒，减少人工催费成本',
      },
      {
        title: '自动对账',
        itemDesc: '财务数据实时统计，一键生成报表',
      },
      {
        title: '透明公示',
        itemDesc: '收费明细线上公开，提升业主信任度',
      },
    ],
  },
  {
    id: 'sys-cb',
    title: '成本高，效率低',
    hoverTitle: '解决方案：智能运维+设备自动化',
    desc: '人工成本持续上涨，巡检、安防、抄表等工作依赖人力，响应速度慢，错误率高，管理效率低下。',
    hoverDesc: '用智能化手段替代人工，降低运维成本，提升响应效率',
    img: '/images/sys-cb.png',
    hoverImg: '/images/sys-cb-l.png',
    hoverItems: [
      {
        title: '智能巡检',
        itemDesc: '定位打卡+拍照上传，替代人工巡检',
      },
      {
        title: '设备自动化',
        itemDesc: '智能抄表、安防监控，减少人工操作',
      },
      {
        title: '任务派单',
        itemDesc: '系统自动分配任务，提升响应速度',
      },
      {
        title: '数据监控',
        itemDesc: '设备状态实时预警，降低故障处理成本',
      },
    ],
  },
  {
    id: 'sys-gd',
    title: '服务散，体验差',
    hoverTitle: '解决方案：全流程服务闭环系统',
    desc: '报修投诉渠道不畅，处理过程不透明，服务响应慢，业主满意度低，缺乏有效的服务评价体系。',
    hoverDesc: '打通报修-派单-处理-评价全流程，提升业主服务体验',
    img: '/images/sys-gd.png',
    hoverImg: '/images/sys-gd-l.png',
    hoverItems: [
      {
        title: '一键报修',
        itemDesc: '业主端小程序提交需求，实时跟踪进度',
      },
      {
        title: '透明处理',
        itemDesc: '服务流程线上可视化，业主可随时查看',
      },
      {
        title: '评价体系',
        itemDesc: '服务完成后业主评分，倒逼服务质量提升',
      },
      {
        title: '多渠道响应',
        itemDesc: '电话+线上双渠道，保障诉求及时受理',
      },
    ],
  },
  {
    id: 'sys-sj',
    title: '数据孤岛，决策难',
    hoverTitle: '解决方案：大数据分析平台',
    desc: '各个系统数据不通，缺乏有效数据分析支撑管理决策，难以实现精细化运营和持续改进。',
    hoverDesc: '整合全维度数据，用数据驱动物业精细化运营决策',
    img: '/images/sys-sj.png',
    hoverImg: '/images/sys-sj-l.png',
    hoverItems: [
      {
        title: '数据整合',
        itemDesc: '打通收费、运维、服务等系统数据',
      },
      {
        title: '可视化看板',
        itemDesc: '经营数据实时展示，直观了解项目状态',
      },
      {
        title: '智能分析',
        itemDesc: '自动生成运营报告，辅助管理决策',
      },
      {
        title: '预测预警',
        itemDesc: '基于数据预测问题，提前优化调整',
      },
    ],
  },
]

export const abilityTabs = [
  { title: '物业管理系统', id: 'system' },
  { title: '业主服务平台', id: 'service' },
  { title: '智能硬件物联', id: 'hardware' },
]

export const abilities: Record<string, Card[]> = {
  system: [
    {
      id: 'SFS-001',
      title: '智能收费系统',
      desc: '自动生成账单、线上多渠道支付、实时对账、智能催缴，收缴率显著提升，财务效率提高80%',
      icon: 'i-custom-sf',
    },
    {
      id: 'CTD-002',
      title: '综合工单调度',
      desc: '报修、投诉线上提交、智能派单、全程跟踪、业主评价，形成服务闭环，提升响应速度与满意度',
      icon: 'i-custom-gd',
    },
    {
      id: 'MPI-003',
      title: '移动巡检巡更',
      desc: '扫码打卡、规范流程、问题实时上报，确保服务质量可追溯，降低管理盲区，提升巡检效率',
      icon: 'i-custom-ydxj',
    },
    {
      id: 'SPLM-004',
      title: '智慧车场管理',
      desc: '无人值守、自动识别、线上缴费，降低人工成本70%，杜绝收费漏洞，提升车场运营效率',
      icon: 'i-custom-zhcc',
    },
    {
      id: 'DDC-005',
      title: '数据决策中心',
      desc: '多维度经营报表、收缴率分析、业主满意度洞察，数据可视化呈现，助力科学决策与精细运营',
      icon: 'i-custom-sjjc',
    },
    {
      id: 'ALM-006',
      title: '资产与租赁管理',
      desc: '房屋、车位、客户档案数字化管理，合同、费用一目了然，提升资产利用率与租赁管理效率。',
      icon: 'i-custom-zczl',
    },
  ],
  service: [
    {
      id: 'OPAR-007',
      title: '在线缴费查账',
      desc: '物业费、车位费、水电煤一键缴纳，账单历史随时可查，缴费凭证电子化保存，便捷又透明。',
      icon: 'i-custom-zxjf',
    },
    {
      id: 'OCRR-008',
      title: '一键报事报修',
      desc: '手机拍照上传问题，实时跟踪处理进度，服务完成后进行评价，让报修过程全程可视化。',
      icon: 'i-custom-bsbx',
    },
    {
      id: 'IAC-009',
      title: '智能门禁通行',
      desc: '手机蓝牙、动态二维码、人脸识别多种方式开门，访客可远程邀请，提升社区安全与便利性。',
      icon: 'i-custom-znmj',
    },
    {
      id: 'CID-010',
      title: '社区信息直达',
      desc: '停水停电、小区通知、政务公告精准推送，重要信息不再错过，提升信息传达效率。',
      icon: 'i-custom-sqxx',
    },
    {
      id: 'NSAM-011',
      title: '邻里服务与商城',
      desc: '物业发布家政、维修等增值服务，业主可在线预约支付，打造社区生活服务生态圈。',
      icon: 'i-custom-llfw',
    },
    {
      id: 'OVAD-012',
      title: '线上投票与议事',
      desc: '重要事项在线投票，议事结果公开透明，提升社区治理效率与业主参与度。',
      icon: 'i-custom-xstp',
    },
  ],
  hardware: [
    {
      id: 'PEE-013',
      title: '人行出入口',
      desc: '人脸识别门禁机、门禁闸机、智能门锁，实现人员进出智能化管理，提升社区安全等级。',
      icon: 'i-custom-rxcrk',
    },
    {
      id: 'VEE-014',
      title: '车行出入口',
      desc: '车牌识别摄像机、智能道闸、车位引导系统，实现车辆无人化值守，提升通行效率。',
      icon: 'i-custom-cxcrk',
    },
    {
      id: 'CSM-015',
      title: '社区安防监控',
      desc: '高清监控摄像机、周界报警、电梯电动车禁入系统、高空抛物监测，打造立体安防体系。',
      icon: 'i-custom-sqaf',
    },
    {
      id: 'SECM-016',
      title: '智慧能耗管理',
      desc: '远程智能水电表、节能控制设备，实现能耗数据实时采集与分析，助力节能降耗。',
      icon: 'i-custom-zhnh',
    },
    {
      id: 'CCF-017',
      title: '便民充电设施',
      desc: '电动汽车充电桩、两轮车智能充电桩，支持多种支付方式，安全可靠，解决社区充电难题。',
      icon: 'i-custom-bmcd',
    },
    {
      id: 'IOT-018',
      title: '物联网平台',
      desc: '统一设备接入与管理平台，打破硬件信息孤岛，实现设备联动与智能场景化控制。',
      icon: 'i-custom-iot',
    },
  ],
}

export const cases: CaseItem[] = [
  {
    title: '知识产权与技术实力',
    desc: '我们坚持自主创新，拥有完整的知识产权体系，为您数字化转型提供可靠、安全、可控的技术保障。',
    img: '/images/zhuanli.jpg',
    link: '/honor-qualification',
    btnText: '查看完整知识产权清单',
    points: [
      {
        title: '5+项专利技术',
        itemDesc: '涵盖智慧社区各核心环节',
      },
      {
        title: '35+项软件著作权',
        itemDesc: '核心产品全栈自研',
      },
      //   {
      //     title: '高新技术企业',
      //     itemDesc: '政府认定的科技型企业',
      //   },
      {
        title: '行业资质认证',
        itemDesc: '符合多项行业标准与规范',
      },
    ],
  },
  {
    title: '成功案例与客户认可',
    desc: '超过300客户选择绘家科技，我们的解决方案在实际应用中不断验证与优化，为客户创造持续价值。',
    img: '/images/anli.jpg',
    link: '/case-studies',
    btnText: '查看详细客户案例',
    points: [
      {
        title: '800+落地项目',
        itemDesc: '覆盖全国30+城市',
      },
      {
        title: '7大业态全覆盖',
        itemDesc: '具备丰富的跨行业经验',
      },
      {
        title: '95%+客户满意度',
        itemDesc: '优质服务赢得市场认可',
      },
      {
        title: '15亿/年账单处理',
        itemDesc: '系统稳定可靠经得起考验',
      },
    ],
  },
]

export const partnersRow1 = [
  { name: '智慧城管理', logo: '/images/partner/zhc.png' },
  { name: '三原华庭', logo: '/images/partner/syht.png' },
  { name: '光华景瑞', logo: '/images/partner/ghjr.png' },
  { name: '高经物业', logo: '/images/partner/gjwy.png' },
  { name: '世贸物业', logo: '/images/partner/smwy.png' },
  { name: '银联商务', logo: '/images/partner/ylsw.png' },
  { name: '第一成美物业', logo: '/images/partner/dycmwy.png' },
  { name: '兆南物业', logo: '/images/partner/znwy.png' },
]
export const partnersRow2 = [
  { name: '衍宏物业', logo: '/images/partner/yhwy.png' },
  { name: '科拓股份', logo: '/images/partner/kegf.png' },
  { name: '海南银行', logo: '/images/partner/hnyh.png' },
  { name: '海康威视', logo: '/images/partner/hkws.png' },
  { name: '珠江物业', logo: '/images/partner/zjwy.png' },
  { name: '华为云', logo: '/images/partner/hwy.png' },
  { name: '嘉元物业', logo: '/images/partner/jywy.png' },
  { name: '招商银行', logo: '/images/partner/zsyh.png' },
]

export const historyYears: HistoryYear[] = [
  {
    year: '2018',
    events: [
      {
        month: '2018-04',
        content:
          '智慧城科技（现绘家科技）团队成立，以“科技赋能生活”为初心，开启智慧社区服务探索之路。',
      },
    ],
  },
  {
    year: '2019',
    events: [
      {
        month: '2019-06',
        content:
          '绘管家v2上线，实现突破：达成首笔线上缴费714.9元，开出首张电子发票，落地项目超100个。',
      },
      {
        month: '2019-10',
        content: '绘管家亮相2019国际物业管理产业博览会，品牌影响力初步彰显。',
      },
    ],
  },
  {
    year: '2020',
    events: [
      {
        month: '2020-02',
        content: '绘服务用户数破10万，在线缴费金额突破5000万元。',
      },
      {
        month: '2020-05',
        content: '绘管家App正式上线，服务触达更便捷。',
      },
    ],
  },
  {
    year: '2021',
    events: [
      {
        month: '2021-06',
        content: '签约物业企业超100家，落地项目增至300余个。',
      },
      {
        month: '2021-10',
        content: '绘服务在线缴费金额突破1亿元大关。',
      },
    ],
  },
  {
    year: '2022',
    events: [
      {
        month: '2022-05',
        content: '收银台v3版本上线，收费流程一站式体验流程闭环。',
      },
      {
        month: '2022-08',
        content: '参与承办《海南智慧社区研讨会》，积极助力行业发展。',
      },
    ],
  },
  {
    year: '2023',
    events: [
      {
        month: '2023-05',
        content: '在线缴费突破3亿元，绘服务v2、绘管家APP v2同步发布。',
      },
      {
        month: '2023-09',
        content: '数字化电子发票功能上线，提升服务合规性。',
      },
    ],
  },
  {
    year: '2024',
    events: [
      {
        month: '2024-05',
        content: '账单/流水系统v3上线，绘服务支付宝小程序、物业大厅同步推出。',
      },
      {
        month: '2024-09',
        content: '实现机械表智能化升级，支持欠费提醒、在线预缴等实用功能。',
      },
      {
        month: '2024-12',
        content: '累计开具电子发票超150万张，涉及金额达6亿元以上。',
      },
    ],
  },
  {
    year: '2025',
    events: [
      {
        month: '2025-03',
        content: '资产管理v3上线，增加资产生涯系统，完善债权归属。',
      },
      {
        month: '2025-09',
        content: '落地项目突破800个，在线缴费金额攀升至8亿元。',
      },
      {
        month: '2025-12-18',
        content: '绘家科技正式启航，迈向智慧生活服务新征程。',
      },
    ],
  },
  {
    year: '2026',
    events: [
      {
        month: '2026-01',
        content: '长路仍在前方，这是我们共同续写的序章。请相信，所有美好终将与我们相遇，未来可期',
      },
    ],
  },
]
